<template>
  <base-modal>
    <z-form ref="form">
      <z-form-group class="row">
        <div class="col-4">
          {{ $t('shared.component.table.field.name') }}
        </div>
        <div class="col-8 pl-0 pr-25">
          <z-form-input :rules="{ required: true, max: 255 }">
            <i-input v-model="form.name" />
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4">
          {{ $t('voice.trunk.field.my_ip') }}
        </div>
        <div class="col-8 pl-0 pr-25 main-ip__tooltip">
          <z-form-input :rules="{ required: true, ip: true }">
            <i-input v-model="form.client" :disabled="ip_disabled" @input="clear" />
            <tooltip
              v-if="ip_disabled"
              theme="light"
              placement="bottom"
              max-width="auto"
              :content="$t('voice.trunk.modal.myip_tooltip')"
            >
              <icon type="ios-help-circle-outline" />
            </tooltip>
          </z-form-input>
          <p v-if="status_is_created" class="form-input__error form-input__error--absolute">
            {{ $t('voice.trunk.modal.ip_exist') }}
          </p>
        </div>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4">
          {{ $t('voice.trunk.field.prefix') }}
        </div>
        <div class="col-8 pl-0 pr-25">
          <z-form-input :rules="{ required: false, prefix: true }">
            <i-input v-model="form.prefix" />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>

    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';
  import { TrunkService } from '@voice/services/TrunkService';

  export default {
    components: {
      BaseModal
    },

    props: {
      id: {
        type: [Number, String],
        default: null
      },

      item: {
        type: Object,
        default: () => ({})
      },

      ip_disabled: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      form: {},
      is_button_loading: false,
      status_is_created: false,
      status_exists: false,
      items: []
    }),

    watch: {
      item: {
        handler: function (val) {
          this.form = defaultsDeep(pick(val, ['name', 'client']), {
            name: '',
            client: '',
            prefix: ''
          });
        },
        immediate: true,
        deep: true
      }
    },
    created() {
      // TrunkService.getSelect().then((data) => (this.items = data));
    },
    methods: {
      compare_ip() {
        this.items.forEach((item) => {
          if (this.ip_disabled) return;
          if (this.form.client === item.client) {
            this.status_is_created = true;
            this.status_exists = true;
          }
        });
      },
      clear() {
        this.status_is_created = false;
        this.status_exists = false;
      },
      save: function () {
        this.compare_ip();
        if (this.status_exists === true) return false;
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_button_loading = true;

            const request = this.id
              ? TrunkService.editItem(this.id, this.form)
              : TrunkService.createItem(this.form);

            request
              .then((res) => this.$emit('success', res))
              .catch((e) => {
                this.$noty.server_error(e);
                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>

<style lang="scss">
  .pr-25 {
    padding-right: 25px !important;
  }

  .z-form-item {
    .main-ip__tooltip {
      .ivu-tooltip {
        position: absolute;
        top: 5px;
        right: -26px;

        &-popper {
          left: -130px !important;
        }

        &-arrow {
          left: 141px !important;
        }

        &-inner {
          width: 150px;
        }

        i {
          font-size: 21px;
        }
      }
    }
  }
</style>
